<app-tenant-lookup-form
  [title]="'Organisatienaam'"
  [message]="'Welkom bij RobotCTRL! Voer de naam van uw organisatie in om toegang te krijgen tot uw dashboard.'"
  [buttonText]="'Doorgaan'"
  (lookupSuccess)="onLookupSuccess($event)"
  (lookupError)="onLookupError($event)"
/>
